var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEditorFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 10.0266L9.92378 15.6002C9.1998 16.283 8.21787 16.6666 7.194 16.6666C6.17013 16.6666 5.18819 16.283 4.46421 15.6002C3.74023 14.9174 3.3335 13.9913 3.3335 13.0257C3.3335 12.0601 3.74023 11.134 4.46421 10.4512L10.3739 4.87756C10.8566 4.42236 11.5112 4.16663 12.1938 4.16663C12.8764 4.16663 13.531 4.42236 14.0136 4.87756C14.4963 5.33277 14.7674 5.95016 14.7674 6.59392C14.7674 7.23767 14.4963 7.85506 14.0136 8.31027L8.09749 13.8839C7.85617 14.1115 7.52886 14.2393 7.18757 14.2393C6.84628 14.2393 6.51897 14.1115 6.27764 13.8839C6.03631 13.6563 5.90073 13.3476 5.90073 13.0257C5.90073 12.7038 6.03631 12.3951 6.27764 12.1675L11.7372 7.02452",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEditorFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-editor-file.8a2c927bc8da43bdef0bb3bf75ff5980.svg";